import { type IWebAnalyticsEntry } from '@reducers/product/types';
import { Statistic, Typography } from 'antd';
import React from 'react';

import { COLOR, SPACING } from '../theme/tokens';

const { Text } = Typography;

export const DAY_OPTIONS = [3, 7, 14, 30, 60] as const;
export type DayInterval = (typeof DAY_OPTIONS)[number];

export default function WebAnalyticsSection({
  entries,
}: {
  entries: IWebAnalyticsEntry[];
}): React.ReactElement {
  if (entries.length === 0) {
    return (
      <Text type="secondary">Žiadne analytické dáta pre zvolené obdobie</Text>
    );
  }

  return (
    <div style={{ display: 'flex', gap: SPACING.lg, flexWrap: 'wrap' }}>
      {entries.map((entry) => (
        <div
          key={entry.provider}
          style={{
            border: `1px solid ${COLOR.borderDefault}`,
            borderRadius: 6,
            padding: `${SPACING.sm}px ${SPACING.md}px`,
            minWidth: 280,
          }}
        >
          <Text strong style={{ display: 'block', marginBottom: SPACING.xs }}>
            {entry.provider}
          </Text>
          <div style={{ display: 'flex', gap: SPACING.xl, flexWrap: 'wrap' }}>
            <Statistic title="Clicks" value={entry.clicks} />
            <Statistic title="Impressions" value={entry.impressions} />
            <Statistic
              title="CTR"
              value={(entry.ctr * 100).toFixed(2)}
              suffix="%"
            />
            <Statistic title="Position" value={entry.position.toFixed(1)} />
          </div>
        </div>
      ))}
    </div>
  );
}
